var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "image-color-properties-wrapper" },
    [
      _c(_setup.ElementLibrarySelector, {
        staticClass: "selector-wrapper",
        attrs: {
          disabled: _setup.disabled,
          "element-list": _setup.colors.model.colorsMap,
          "library-id": _setup.colors.model.libraryId,
          "library-type": _setup.COLOR_TYPE,
          "selected-position": _setup.colors.model.option,
          cmyk: _vm.cmykMode,
        },
        on: {
          "option-selected": _setup.colors.onColorSelected,
          "load-option": _setup.colors.loadColorIntoElement,
          "options-reordered": _setup.colors.onColorOptionsReordered,
          "remove-map-option": _setup.colors.removeColorOption,
          "remove-library": _setup.colors.removeColorLibrary,
          "pick-library": _setup.colors.pickColorLibrary,
          "preview-selection": _setup.colors.previewColorOption,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }